import { defineMessages } from 'react-intl';

export const shipFromStepMessages = defineMessages({
  selectShipFromLabel: {
    defaultMessage: 'Select Ship From Location',
    id: 'fK9o+n',
    description: 'Label for the ship-from location dropdown in the booking wizard',
  },
  shipFromPlaceholder: {
    defaultMessage: 'Select a location',
    id: 'PJ1Mcj',
    description: 'Placeholder for the ship-from location dropdown',
  },
  addShipFrom: {
    defaultMessage: '+ Add Ship From',
    id: '4QMGRq',
    description: 'Link to add a new ship-from location',
  },
  shipDateLabel: {
    defaultMessage: 'Ship Date',
    id: 'fLtlRF',
    description: 'Label for the ship date input',
  },
  shipDatePlaceholder: {
    defaultMessage: 'Pick a date',
    id: 'vfav1F',
    description: 'Placeholder for the ship date picker when no date is selected',
  },
  pickupServicesHeader: {
    defaultMessage: 'Pickup Services',
    id: 'vWg7fU',
    description: 'Header for the pickup services checkbox grid',
  },
  summaryShipDate: {
    defaultMessage: 'Ship Date: {date}',
    id: 'KOPhA0',
    description: 'Ship date label in the collapsed ship-from summary',
  },
  summaryLocationLabel: {
    defaultMessage: 'Location',
    id: 'v5/hbS',
    description: 'Label above the ship-from location name and address in the collapsed summary',
  },
  tradeshowNameLabel: {
    defaultMessage: 'Tradeshow Name *',
    id: 'OjmsrC',
    description: 'Label for the required tradeshow name field revealed by Tradeshow Pickup',
  },
  boothNumberLabel: {
    defaultMessage: 'Booth Number *',
    id: '2jpt9b',
    description: 'Label for the required booth number field revealed by Tradeshow Pickup',
  },
  pickupReadyTimeLabel: {
    defaultMessage: 'Pickup Ready Time',
    id: 'dxOTb1',
    description: 'Label for the pickup ready time input',
  },
  pickupCloseTimeLabel: {
    defaultMessage: 'Pickup Close Time',
    id: 'y3Xdj9',
    description: 'Label for the pickup close time input',
  },
  arrangePickupSeparately: {
    defaultMessage: 'I will arrange a pickup with the carrier separately',
    id: '+0Ebtl',
    description: 'Checkbox label to opt out of automatic carrier pickup scheduling',
  },
  pickupWindowLabel: {
    defaultMessage: 'Pickup Window',
    id: 'pvTv7C',
    description: 'Label for the pickup window section in the collapsed ship-from summary',
  },
  summaryPickupWindow: {
    defaultMessage: 'Between {from} - {to}{tz}',
    id: 'XPJ4Sj',
    description:
      'Formatted pickup window range shown in the collapsed ship-from summary; {tz} is a space-prefixed timezone abbreviation like " CST" or empty string',
  },
  summaryTradeshowName: {
    defaultMessage: 'Tradeshow: {name}',
    id: 'cplkcO',
    description: 'Tradeshow name line in the collapsed ship-from summary',
  },
  summaryBoothNumber: {
    defaultMessage: 'Booth: {booth}',
    id: 'QG2nRj',
    description: 'Booth number line in the collapsed ship-from summary',
  },
  editShipFrom: {
    defaultMessage: 'Edit ship from',
    id: 'Qela84',
    description: 'Link below the Ship From dropdown to open the location edit modal',
  },
  addPickupInstructions: {
    defaultMessage: 'Add Pickup Instructions',
    id: 'cVUDII',
    description: 'Toggle link to reveal the pickup instructions textarea in the Ship From wizard step',
  },
  pickupInstructionsLabel: {
    defaultMessage: 'Pickup Instructions',
    id: '6RD6lQ',
    description: 'Label for the pickup instructions textarea in the Ship From wizard step',
  },
  saveAsDefaultSelections: {
    defaultMessage: 'Save as default selections for this Ship From Location',
    id: 'r6O+Vt',
    description: 'Checkbox label to save pickup times, services, and instructions as defaults for this location (no existing defaults)',
  },
  updateDefaultSelections: {
    defaultMessage: 'Update default selections for this Ship From Location',
    id: 'XeVF20',
    description: 'Checkbox label to update existing LTL defaults for this location (defaults already exist)',
  },
  ltlDefaultsHelperText: {
    defaultMessage:
      'These Pickup Times, Services, and Instructions will apply to all future LTL shipments that use this Ship From Location. Defaults can be managed in your Ship From Location settings.',
    id: 'SR+lZ+',
    description: 'Helper text below the save-as-default checkbox in the Ship From wizard step',
  },
});
